import {updateUrlParams} from '../../../shared-deprecated/updateUrlParams';
import {FIRST_PRODUCT_ID_PARAM} from '../../firstProductId/useFirstProductIds';

/**
 * - When changing filters these blacklisted params should be removed from the url.
 */
const blackListedParams = [FIRST_PRODUCT_ID_PARAM];

export const getUpdatedFilterParams = ({
  search,
  update,
}: {
  search?: string;
  update: Map<string, Array<string> | undefined>;
}): string | undefined => {
  const modifiedUpdates = blackListedParams.reduce(
    (acc, curr) => acc.set(curr, undefined),
    update,
  );

  return updateUrlParams({search, update: modifiedUpdates});
};
